import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ValidationInvocationState } from './validations.state';
import { validationsKey } from './validations-reducers';

const selectValidationsFeatureState = createFeatureSelector<ValidationInvocationState>(validationsKey);

export const selectValidations = createSelector(selectValidationsFeatureState, (state) => state.marginValidations);
